import { TimelineLite, TweenLite, TweenMax } from "gsap/all";
import * as THREE from "three";
import getIntroAnimations, { preloaderAnimation } from "./animations/intro";
import getStudyAnimation from "./animations/study";
import Questions from "./components/questions";
import Result from "./components/result";
import Timeline from "./components/timeline";
import { FACE_TRANSITION_PHASES, INTRO_SPRITE_SRC } from "./const";
import { checkIsDesktop, onResize, updateViewportUnits } from "./helpers";
import initParticles from "./particles";
import App from "./particles/App";
import { gsap } from "gsap/all";
import isMobile from "is-mobile";
class Main {
    constructor() {
        this.classes = {
            secondScreenHandler: ".js-open-second-screen",
            intro: ".js-intro",
            introScreen: ".js-intro-sub-screen",
            study: ".js-study",
            questions: ".js-questions",
            result: ".js-result",
            goNext: ".js-go-next",
            shareBtn: ".js-share",
        };
        this.activeClasses = {
            blurred: "is-blurred",
        };
        this.introSpriteSrc = INTRO_SPRITE_SRC;
        this.introEl = document.querySelector(this.classes.intro);
        this.studyEl = document.querySelector(this.classes.study);
        this.questionsEl = document.querySelector(this.classes.questions);
        this.resultEl = document.querySelector(this.classes.result);
        this.shareBtn = null;
        this.introScreensEls = Array.from(document.querySelectorAll(this.classes.introScreen));
        this.secondScreenBtn = document.querySelector(this.classes.secondScreenHandler);
        this.restart = this.restart.bind(this);
        this.startResult = this.startResult.bind(this);
    }
    restart() {
        this.questions.destroy();
        this.timeline.reset();
        TweenLite.set(this.studyEl, { display: 'none' });
        TweenLite.set(this.questionsEl, { display: 'none' });
        TweenLite.set(this.resultEl, { display: 'none' });
        TweenLite.set('.js-floating-points-video-wrap', { autoAlpha: 0 });
        document.querySelector('.js-current').innerHTML = '1';
        this.introScreensEls.forEach(screen => TweenLite.set(screen, { autoAlpha: 0, display: 'none' }));
        // const firstScreenEl = this.introScreensEls[this.introScreensEls.length];
        TweenLite.set(this.introEl, { display: 'flex' });
        TweenLite.set('.js-intro-scene-3', { display: 'flex' });
        TweenMax.to('.js-intro-scene-3', 1, {
            autoAlpha: 1,
            onStart: () => {
                this.introEl.classList.remove('is-light');
            },
        });
    }
    reDraw() {
        // if (this.timeline) this.timeline.reDraw();
        // if (this.camera) this.camera.reDraw();
        if (this.app)
            this.app.animate();
    }
    toggleBlurred(active = true) {
        if (active) {
            document.body.classList.add(this.activeClasses.blurred);
        }
        else {
            document.body.classList.remove(this.activeClasses.blurred);
        }
    }
    resize() {
        if (this.app)
            this.app.resize();
        // if (this.timeline) this.timeline.onResize();
        // if (this.camera) this.camera.onResize();
    }
    initGoNextHandler(callback, from = this.introEl, to = this.studyEl) {
        const goNextBtn = document.querySelector(this.classes.goNext);
        goNextBtn.addEventListener("click", () => {
            this.toggleScreens(callback, from, to);
            window.analytics.trackAction('click_next');
        }, { once: true });
    }
    toggleScreens(callback, from = this.introEl, to = this.studyEl) {
        const tl = new TimelineLite({ paused: true, onComplete: callback });
        tl.to(from, 1, {
            autoAlpha: 0,
            onComplete: () => {
                from.setAttribute("style", "display: none");
                to.setAttribute("style", "display: block");
            },
        }).fromTo(to, 1, { autoAlpha: 0 }, { autoAlpha: 1 });
        tl.play();
    }
    startResult(results, phase) {
        this.result.init();
        this.result.setValues({ results, phase, particles: this.app.webgl.particles });
        const { random, curl, scale } = FACE_TRANSITION_PHASES[phase];
        this.result.finalAnimation({ random, curl, scale });
    }
    startQuestions() {
        this.toggleBlurred(false);
        this.questions.init({
            timeline: this.timeline,
            particles: this.app.webgl.particles,
            goToResults: (results, phase) => {
                this.app.webgl.particles.goToPhase(phase);
                this.toggleScreens(() => this.startResult(results, phase), this.questionsEl, this.resultEl);
            },
        });
        this.app.setQuestions(this.questions);
    }
    startStudy(img) {
        if (this.app) {
            this.app.destroy();
        }
        this.app = new App({
            texture: img,
        });
        this.app.init(true);
        this.toggleScreens(() => {
            if (!this.timeline) {
                this.timeline = new Timeline();
            }
            const tl = getStudyAnimation();
            tl.play();
            this.initGoNextHandler(() => {
                this.startQuestions();
            }, this.studyEl, this.questionsEl);
        });
    }
    initHandlers() {
        this.result = new Result();
        const file = document.querySelector('[data-gallery]');
        file.addEventListener('change', ({ target }) => {
            window.analytics.trackAction('click_with_photo');
            setTimeout(() => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    document.body.classList.remove('is-popup-opened');
                    window.analytics.trackAction('photo_loaded');
                    const img = e.target.result;
                    // @ts-ignore
                    this.startStudy(img);
                };
                reader.readAsDataURL(target.files[0]);
            }, 100);
        });
        this.secondScreenBtn.addEventListener("click", () => {
            window.analytics.trackAction('click_without_photo');
            document.body.classList.remove("is-second-intro-bg-shown");
            document.body.classList.remove('is-popup-opened');
            this.startStudy("");
        });
        this.result.on('onRestart', this.restart);
    }
    playIntroAnimation() {
        const tl = new TimelineLite({
            paused: true,
            delay: 2,
        });
        const screens = this.introScreensEls;
        const introAnimations = getIntroAnimations();
        screens.forEach((el, index) => {
            const sceneTl = introAnimations[index];
            const isNotLastScene = index !== screens.length - 1;
            const isLastScene = index === screens.length - 1;
            const screenTl = new TimelineLite({
                onStart: () => {
                    el.setAttribute("style", "display: flex");
                    if (isLastScene) {
                        setTimeout(() => {
                            introAnimations[introAnimations.length - 1].play(0);
                            window.analytics.trackAction('screen_0_add_photo');
                        }, 14000);
                    }
                },
                onComplete: () => {
                    if (isNotLastScene) {
                        el.setAttribute("style", "display: none");
                    }
                },
            }).to(el, 0.6, { autoAlpha: 1 });
            const screenName = `screen-${index + 1}`;
            const sceneName = `scene-${index + 1}`;
            if (sceneTl) {
                screenTl.add(sceneName, 2);
                screenTl.add(sceneTl.play(0), sceneName);
            }
            tl.add(screenName);
            tl.add(screenTl, screenName);
        });
        tl.play();
    }
    preload(callback) {
        const LOADED_ACTIONS = [
            {
                id: 'loaded_0',
                value: 0,
            },
            {
                id: 'loaded_50',
                value: 50,
            },
            {
                id: 'loaded_100',
                value: 100,
            }
        ];
        const triggeredLoadingPercent = [];
        const loader = new THREE.FileLoader();
        loader.load(this.introSpriteSrc, () => {
            callback();
        }, xhr => {
            const count = document.getElementById("loadCount");
            const value = Math.floor((xhr.loaded / xhr.total) * 100);
            LOADED_ACTIONS.map(({ id, value: percent }) => {
                if (value >= percent && !triggeredLoadingPercent.includes(percent)) {
                    triggeredLoadingPercent.push(percent);
                    window.analytics.trackAction(id);
                }
            });
            count.innerHTML = `${value}%`;
        });
    }
    init() {
        const preloader = document.querySelector('.js-loader');
        fetch(`./${LANG}.json`)
            .then(res => res.json())
            .then(data => {
            this.data = data;
            this.questions = new Questions({ data });
            // TweenLite.set(preloader, { autoAlpha: 0 });
            // this.initHandlers();
            // this.checkCamera(false);
            preloaderAnimation().play();
            this.preload(() => {
                TweenLite.set(preloader, { autoAlpha: 0 });
                gsap.timeline()
                    .to('.js-bg', 1, { autoAlpha: 1, ease: 'Quad.easeIn' })
                    .fromTo(['.js-qr', '.js-slogan'], 0.8, { autoAlpha: 0, y: 30 }, { autoAlpha: 1, y: 0, ease: 'Quad.easeInOut' });
                this.playIntroAnimation();
                this.initHandlers();
                const noiseLoader = new THREE.FileLoader();
                noiseLoader.load("./../img/bg.gif");
            });
        });
    }
}
const initData = (isMobileDevice = true) => {
    if (!isMobileDevice) {
        [...document.querySelectorAll('[data-desktop-src]')].forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.src = item.dataset.desktopSrc;
        });
    }
};
const onDomContentLoaded = () => {
    document.removeEventListener("DOMContentLoaded", onDomContentLoaded);
    initData(isMobile());
    const webgl = document.getElementById("webgl");
    if (webgl) {
        // const points = new Points();
        // points.init();
        initParticles();
        return;
    }
    const main = new Main();
    main.init();
    onResize(() => {
        updateViewportUnits();
        main.resize();
    });
    let prevDate = Date.now();
    (function tick() {
        window.requestAnimationFrame(tick);
        const currentDate = Date.now();
        if (currentDate - prevDate < 60) {
            return;
        }
        prevDate = currentDate;
        if (main.camera || main.app) {
            main.reDraw();
        }
    })();
};
document.addEventListener("DOMContentLoaded", onDomContentLoaded);
updateViewportUnits();
checkIsDesktop();
